import { Icon } from '@y42/core/icon';
import { Y42FeatureType } from '@y42/json-schema';
import {
  alertIcon,
  alertStrokeIcon,
  dataCatalogIcon,
  dataCatalogStrokeIcon,
  dataLineageIcon,
  dataLineageStrokeIcon,
  datasourceTableIcon,
  exportIcon,
  exportStrokeIcon,
  exportTriggerIcon,
  integrationIcon,
  integrationStrokeIcon,
  orchestrationIcon,
  orchestrationStrokeIcon,
  sqlModelIcon,
  sqlModelStrokeIcon,
  uiModelIcon,
  uiModelStrokeIcon,
  visualizationDashboardIcon,
  visualizationDashboardStrokeIcon,
  visualizationDashboardTabIcon,
  visualizationIcon,
  visualizationWidgetIcon,
  visualizationWidgetStrokeIcon,
} from '../icons';

export const Y42FeatureTypeToLogo: Record<Y42FeatureType, Icon> = {
  [Y42FeatureType.Integration]: integrationIcon,
  [Y42FeatureType.UiModel]: uiModelIcon,
  [Y42FeatureType.SqlModel]: sqlModelIcon,
  [Y42FeatureType.Orchestration]: orchestrationIcon,
  [Y42FeatureType.VisualizationDashboard]: visualizationDashboardIcon,
  [Y42FeatureType.VisualizationWidget]: visualizationWidgetIcon,
  [Y42FeatureType.VisualizationFilter]: visualizationIcon,
  [Y42FeatureType.VisualizationTheme]: visualizationIcon,
  [Y42FeatureType.Export]: exportIcon,
  [Y42FeatureType.StatusAlert]: alertIcon,
  [Y42FeatureType.Lineage]: dataLineageIcon,
  [Y42FeatureType.Catalog]: dataCatalogIcon,
};

export const Y42FeatureTypeToLogoStroke: Record<Y42FeatureType, Icon | null> = {
  [Y42FeatureType.Integration]: integrationStrokeIcon,
  [Y42FeatureType.UiModel]: uiModelStrokeIcon,
  [Y42FeatureType.SqlModel]: sqlModelStrokeIcon,
  [Y42FeatureType.Orchestration]: orchestrationStrokeIcon,
  [Y42FeatureType.VisualizationDashboard]: visualizationDashboardStrokeIcon,
  [Y42FeatureType.VisualizationWidget]: visualizationWidgetStrokeIcon,
  [Y42FeatureType.VisualizationFilter]: null,
  [Y42FeatureType.VisualizationTheme]: null,
  [Y42FeatureType.Export]: exportStrokeIcon,
  [Y42FeatureType.StatusAlert]: alertStrokeIcon,
  [Y42FeatureType.Lineage]: dataLineageStrokeIcon,
  [Y42FeatureType.Catalog]: dataCatalogStrokeIcon,
};

export const Y42FeatureTypeToChildLogo: Record<Y42FeatureType, Icon | ''> = {
  [Y42FeatureType.Integration]: datasourceTableIcon,
  [Y42FeatureType.UiModel]: datasourceTableIcon,
  [Y42FeatureType.SqlModel]: datasourceTableIcon,
  [Y42FeatureType.Orchestration]: '',
  [Y42FeatureType.VisualizationDashboard]: visualizationDashboardTabIcon,
  [Y42FeatureType.VisualizationWidget]: '',
  [Y42FeatureType.VisualizationFilter]: '',
  [Y42FeatureType.VisualizationTheme]: '',
  [Y42FeatureType.Export]: exportTriggerIcon,
  [Y42FeatureType.StatusAlert]: '',
  [Y42FeatureType.Lineage]: '',
  [Y42FeatureType.Catalog]: '',
};
